// extracted by mini-css-extract-plugin
module.exports = {"Container":"ORG-q4Gd","CandidateRegistration":"_37CR5knJ","Title":"rD515A06","applyFormContainer":"_10Foi7Wg"};
    if(module.hot) {
      // 1754514925063
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  